<div class="main_content px-3 position-relative">

    <div class="container-fluid py-3">
        <div class="title mb-4">
            <h3>My Cashbacks</h3>
        </div>
        <div class="my-2">
            <button class="btn btn-success" (click)="openModal(UploadFileModal)">
                <i class="fa-solid fa-plus"></i> Add Cashback
            </button>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 ">
                <div class="white_box shadow p-3">
                    <div class="row">
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-4" *ngFor="let item of cashbacks; let i = index;">
                            <div class="card h-100 position-relative border shadow rounded-lg">
                                <img loading="lazy" [src]="imgUrl + item.file" class="card-img-top rounded-lg"
                                    alt="Gallery Image" style="width: 100%; height: 200px; object-fit: cover;">
                                <div class="btn-group position-absolute top-0 m-2" style="right: 0;" role="group"
                                    aria-label="Action buttons">
                                    <button type="button" class="btn btn-primary" (click)="handleEdit(item)">
                                        <i class="fa-solid fa-edit"></i>
                                    </button>
                                    <button type="button" class="btn btn-danger" (click)="handleDelete(item.id)">
                                        <i class="fa-solid fa-trash"></i>
                                    </button>
                                    <button type="button" class="btn btn-secondary"
                                        (click)="handleView(item.id); modalService.open(ViewDetailModal)">
                                        <i class="fa-solid fa-list"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pagination-controls mt-4 d-flex justify-content-end">
                        <button class="btn btn-secondary" (click)="previousPage()" [disabled]="currentPage === 1">
                            Previous
                        </button>
                        <span class="mx-2">Page {{currentPage}} of {{totalPages}}</span>
                        <button class="btn btn-secondary" (click)="nextPage()" [disabled]="currentPage === totalPages">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #UploadFileModal let-modal>
    <div class="modal-content">
        <div class="card">
            <div class="card-header text-dark d-flex justify-content-between align-items-center">
                <h5 class="modal-title mb-0">{{ cashbackId ? 'Edit' : 'Add' }} Cashback</h5>
                <button type="button" class="btn-close btn-close-white" aria-label="Close"
                    (click)="modalService.dismissAll()"></button>
            </div>
            <div class="card-body">
                <p class="card-text">Please select a file to upload.</p>
                <div class="mb-3">
                    <input class="form-control" type="file" accept="image/*" (change)="onFileSelected($event)" />
                    <div *ngIf="thumbnail" class="thumbnail-preview mt-3">
                        <img loading="lazy" [src]="thumbnail" alt="Thumbnail Preview" class="img-thumbnail" />
                    </div>
                </div>
                <div class="mb-3">
                    <label for="cashbackValue" class="form-label">Cashback Value</label>
                    <input type="number" class="form-control" id="cashbackValue" [(ngModel)]="cashbackValue"
                        placeholder="Enter cashback value" />
                </div>

                <div class="mb-3">
                    <label for="">Terms and Conditions</label>
                    <app-editor [(innerValue)]="termsAndConditions"></app-editor>
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
                <button type="button" class="btn btn-primary mr-2" (click)="handleUpload()" [disabled]="isUploading">
                    <i class="fas fa-save"></i> Save
                </button>
                <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()"
                    [disabled]="isUploading">
                    <i class="fas fa-times"></i> Cancel
                </button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #ViewDetailModal let-modal>
    <div class="modal-content">
        <div class="card">
            <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                <h5 class="modal-title mb-0">Cashback Details</h5>
                <button type="button" class="btn-close btn-close-white" aria-label="Close"
                    (click)="modalService.dismissAll()"></button>
            </div>
            <div class="card-body">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Name</th>
                            <th scope="col">Referrer</th>
                            <th scope="col">Claimed At</th>
                            <th scope="col">Receipt File</th>
                            <th scope="col">Receipt Value</th>
                            <th scope="col">Receipt No</th>
                            <th scope="col">Status</th>
                            <th scope="col">Pay Now</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of cashback.appUserReferralHistories; let i = index">
                            <th scope="row">{{ i + 1 }}</th>
                            <td>{{ item.appUser.phone }}</td>
                            <td>{{ item.appUser.profileCharacterName }}</td>
                            <td *ngIf="item.appUserReferral">{{ item.appUserReferral.userReferralCode }} - {{
                                item.appUserReferral.appUser?.profileCharacterName || '-' }}</td>
                            <td *ngIf="!item.appUserReferral">-</td>
                            <td>{{ item.createdAt | date }}</td>
                            <td>
                                <img loading="lazy" [src]="imgUrl + item.receiptFile" alt="Receipt File"
                                    style="width: 150px;" class="img-thumbnail"
                                    (click)="openModalImage(ImageView, imgUrl + item.receiptFile)" />
                            </td>
                            <td>
                                ${{ item.receiptValue || '0' }}
                            </td>
                            <td>
                                {{ item.receiptNo }}
                            </td>
                            <td>
                                <select class="form-select" (change)="handleChangeStatus(item.id, $event)"
                                    [(ngModel)]="item.status">
                                    <option [value]="0" [selected]="item.status === 0">Pending</option>
                                    <option [value]="1" [selected]="item.status === 1">Success</option>
                                    <option [value]="2" [selected]="item.status === 2">Reject</option>
                                </select>
                            </td>
                            <td>
                                <select (change)="onPayNowChange($event, item.id)" [(ngModel)]="item.isPaid">
                                    <option [value]="0">No</option>
                                    <option [value]="1">Yes</option>
                                </select>
                            </td>

                        </tr>

                        <tr *ngIf="cashback.appUserReferralHistories.length == 0">
                            <td colspan="7" class="text-center">No data</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer d-flex justify-content-end">
                <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #ImageView let-modal>
    <div class="modal-content">
        <img loading="lazy" [src]="imageView" alt="Receipt File" />
    </div>
</ng-template>